import React from "react";
import {CustomerAccountOverview} from "./CustomerAccountOverview";
import {ExclusiveSaleBanner} from "./ExclusiveSaleBanner";
import * as ReactDOM from "react-dom";
import CustomerContextProvider from "../CustomerContextProvider/CustomerContextProvider";

export const CustomerAccount: React.FC<{ element: HTMLElement }> = (props) => {
  return (
    <React.Fragment>
      <ExclusiveSaleBanner element={props.element}/>
      <CustomerAccountOverview element={props.element}/>
    </React.Fragment>
  );
};

export const initialise = (element: HTMLElement): void => {
  ReactDOM.render(
    <React.Suspense fallback={null}>
      <CustomerContextProvider>
        <CustomerAccount element={element}/>
      </CustomerContextProvider>
    </React.Suspense>,
    element,
  );
};
